import React, { FC, memo, useCallback } from 'react';
import { Button, Modal } from 'udesk-ui';
import { ButtonProps } from 'udesk-ui/lib/button';
import UdeskLocales from 'UdeskLocales';

interface TemplateProps extends ButtonProps {
    onOk?: () => void;
}

const Template: FC<TemplateProps> = memo((props) => {
    const { onOk, ...restProps } = props;

    const onFinalReview = useCallback(() => {
        Modal.confirm({
            title: /* 确认终审吗？ */UdeskLocales['current'].pages.qualityInspectionList.detail.components.finalReview.index.confirmedFinal,
            content: /* 终审后，仅支持执行终审、归档操作 */UdeskLocales['current'].pages.qualityInspectionList.detail.components.finalReview.index.afterTheFinalReviewOnlyTheFinalReviewAndFilingOperationsAreSupported,
            onOk: () => {
                onOk?.();
            },
        });
    }, []);

    return (
        <Button type="primary" onClick={onFinalReview} {...restProps}>{/* 终审 */}{UdeskLocales['current'].pages.qualityInspectionList.detail.components.finalReview.index.finalAppeal}</Button>
    );
});

export default Template;
